import { render } from "./IconFlame.vue?vue&type=template&id=7e4168e1&scoped=true"
import script from "./IconFlame.vue?vue&type=script&lang=js"
export * from "./IconFlame.vue?vue&type=script&lang=js"

import "./IconFlame.vue?vue&type=style&index=0&id=7e4168e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4168e1"]])

export default __exports__